export default function FullPageSpinner({ show, text = "Processing..." }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4">
        <div className="h-14 w-14 animate-spin rounded-full border-4 border-white/30 border-t-white"></div>

        <p className="text-white text-sm font-medium tracking-wide">
          {text}
        </p>
      </div>
    </div>
  );
}